import { useContext } from 'react';
import { PluginContext } from './context';
import { PluginProviderCtx } from '../types';

export const usePluginCtx = (): PluginProviderCtx => {
  const ctx = useContext(PluginContext);
  if (!ctx) throw new Error('Missing Plugin.Provider in the entry');
  return ctx;
};
